module.exports = __webpack_public_path__ + "static/media/carrierExplosions.0637be0a.svg";